/* eslint-disable indent */
import { createReducer, on } from '@ngrx/store';
import { Automation } from '../models';
import * as AutomationDetailsActions from './automation-details.actions';

export interface AutomationDetailsState {
  automation: Automation | null;
  loading: boolean;
  error: string | null;
}

export const initialState: AutomationDetailsState = {
  automation: null,
  loading: false,
  error: null,
};

export const automationDetailsReducer = createReducer(
  initialState,
  on(AutomationDetailsActions.loadAutomationDetails, state => ({
    ...state,
    automation: null,
    loading: true,
    error: null,
  })),
  on(AutomationDetailsActions.loadAutomationDetailsSuccess, (state, { automation }) => ({
    ...state,
    automation,
    loading: false,
    error: null,
  })),
  on(AutomationDetailsActions.loadAutomationDetailsFailure, (state, { error }) => ({
    ...state,
    automation: null,
    loading: false,
    error,
  })),
  on(AutomationDetailsActions.updateAutomationDetails, state => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(AutomationDetailsActions.updateAutomationDetailsSuccess, (state, { automation }) => ({
    ...state,
    automation,
    loading: false,
    error: null,
  })),
  on(AutomationDetailsActions.updateAutomationDetailsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(AutomationDetailsActions.addDocumentToAutomation, (state, { automationId, document }) => ({
    ...state,
    automation:
      state.automation && state.automation._id === automationId
        ? {
            ...state.automation,
            documents: [...(state.automation.documents || []), document],
          }
        : state.automation,
  })),
  on(AutomationDetailsActions.updateDocumentInAutomation, (state, { automationId, documentId, data }) => ({
    ...state,
    automation:
      state.automation && state.automation._id === automationId
        ? {
            ...state.automation,
            documents: (state.automation.documents || []).map(doc =>
              doc._id === documentId
                ? {
                    ...doc,
                    ...data,
                  }
                : doc
            ),
          }
        : state.automation,
  })),
  on(AutomationDetailsActions.resetAutomationDetails, () => initialState)
);
